import { Card } from "@pacificoseguros/pixie/react";
import React from "react";
import icDetail from "../../../assets/icons/ic-detalle.svg";
import icPaso2 from "../../../assets/icons/ic-paso-dos.svg";
import icPaso3 from "../../../assets/icons/ic-paso-tres.svg";
import icPaso1 from "../../../assets/icons/ic-paso-uno.svg";
import {
    Column,
    FlexLayout,
    Row,
} from "../../../components/layout/flex-layout";
import { SizedBox } from "../../../components/layout/sized-box";
import { SpacingBox } from "../../../components/layout/spacing-box";
import { Typography } from "../../../components/typography/typography";
import { WaveInverse } from "../../../components/waves/WaveInverse";
import { useWindowResize } from "../../../hooks/use-windows-resize";
import { LandingConsumer } from "../providers/landing-provider";

const steps = [
    {
        img: <img src={icPaso1} height={50} alt="paso 1" />,
        content: (
            <p>
                <Typography variant="secondary">
                    <b>Cotiza</b>
                </Typography>{" "}
                el seguro en<br></br>un solo paso
            </p>
        ),
        footer: (
            <Typography variant="secondary">
                Conocerás el precio estimado<br></br>llenando <b>pocos datos</b>
            </Typography>
        ),
    },
    {
        img: <img src={icPaso2} height={50} alt="paso 2" />,
        content: (
            <p>
                <Typography variant="secondary">
                    <b>Elige</b>
                </Typography>{" "}
                el pago y periodo de<br></br>declaración de tu planilla
            </p>
        ),
        footer: (
            <Typography variant="secondary">
                Puedes elegir entre el periodo<br></br>
                <b>anual o semestral</b>
            </Typography>
        ),
    },
    {
        img: <img src={icPaso3} height={50} alt="paso 3" />,
        content: (
            <p>
                <Typography variant="secondary">
                    <b>Sube</b>
                </Typography>{" "}
                la planilla de tus<br></br>trabajadores y{" "}
                <Typography variant="secondary">
                    <b>paga</b>
                </Typography>
            </p>
        ),
        footer: (
            <LandingConsumer>
                {(value) => (
                    <div onClick={() => value.setOpenedPayrollModal(true)}>
                        <Typography variant="secondary" decoration="underline">
                            Conoce los datos que necesitamos<br></br>para
                            completar el archivo
                        </Typography>
                    </div>
                )}
            </LandingConsumer>
        ),
    },
];

export const LandingHowToBuySection = () => {
    const { isMobile } = useWindowResize();
    return (
        <div
            data-testid="LandingHowToBuySection"
            className="landing-how-to-buy-section"
        >
            <WaveInverse reverse flip />
            <SpacingBox mt={35} />
            <Typography variant="secondary" fontSize={isMobile ? 23 : 26}>
                {isMobile ? (
                    <b>
                        Conoce cómo comprar<br></br>el Seguro Vida Ley
                    </b>
                ) : (
                    <b>
                        Conoce cómo comprar el Seguro<br></br>Vida Ley
                    </b>
                )}
            </Typography>
            <SpacingBox mt={45} />
            <FlexLayout
                direction={isMobile ? "column" : "row"}
                justify={isMobile ? "flex-start" : "center"}
                align={isMobile ? "center" : "stretch"}
            >
                {steps.map((step, i) => (
                    <SpacingBox
                        ml={i === 0 || isMobile ? 0 : 45}
                        pt={16}
                        key={i}
                    >
                        <SizedBox width={isMobile ? 280 : 300}>
                            <Card
                                key={i}
                                className="landing-how-to-buy-section__item"
                            >
                                <SpacingBox py={25}>
                                    <Column align="center">
                                        {step.img}
                                        <SpacingBox mt={15} />
                                        <Typography fontSize={20}>
                                            {step.content}
                                        </Typography>
                                        <SpacingBox mt={5} />
                                        <Typography fontSize={16}>
                                            {step.footer}
                                        </Typography>
                                    </Column>
                                </SpacingBox>
                            </Card>
                        </SizedBox>
                    </SpacingBox>
                ))}
            </FlexLayout>
            <SpacingBox mt={30} />
            <Row align="center" justify="center">
                <img src={icDetail} alt="detalle" />
                <SpacingBox ml={15} />
                <a
                    href={process.env.REACT_APP_DETALLE_PDF_URL}
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    <Typography variant="secondary" decoration="underline">
                        Conoce el detalle de todas nuestras<br></br>coberturas y
                        beneficios aquí
                    </Typography>
                </a>
            </Row>
            <SpacingBox pt={35} />
        </div>
    );
};
